module.exports = __webpack_public_path__ + "img/SEND.449efe0f.svg";